import Vue from 'vue'
import Message from './Message.vue'
import Loading from './loading.vue'

const MessageBox = Vue.extend(Message);
const LoadingBox = Vue.extend(Loading);
Message.newInstance = (content, timeout, styles) => {

    let options = {};

    if(content) {
        options.content = content;
    }
    if(timeout) {
        options.timeout = timeout;
    }
    if(styles) {
        options.styles = styles;
    }

    let instance = new MessageBox({
        data: options
    }).$mount();

    document.body.appendChild(instance.$el);

    Vue.nextTick(() => {
        instance.visible = true
    });

};


let loadingInstance,
    loadingCallback;

Loading.newLoading = (visible,content,timeout,callback) =>{

    let options = {};

    options.visible = visible

    if(content){
        options.content = content;
    }

    if(timeout){
        options.timeout = timeout;
    }

    if(callback){
        options.callback = callback;

        loadingCallback =  setTimeout(()=>{
            callback && callback();
        },timeout * 1000)
    }

    loadingInstance = new LoadingBox({
        data:options
    }).$mount();

    document.body.appendChild(loadingInstance.$el);

    Vue.nextTick(() => {
        loadingInstance.visible = visible
    });
}

export default {
    info: Message.newInstance,

    load: (data) => {

        if(data) {

            if(loadingInstance){
                loadingInstance.$set(loadingInstance,'visible',true);
            }else{
                return Loading.newLoading(data);
            }

        }
        else {

            if(loadingInstance) {

                loadingInstance.$set(loadingInstance,'visible',false);
                clearTimeout(loadingCallback);
            }
        }
    }
};
